import React from "react";

const TableDetailList = ({ className, inline, value, title }) => {
    const classes = `card-dl${className ? ' ' + className : ''}${inline ? ' d-flex' : ''}`;
    if (value === undefined || value === "" || (Array.isArray(value) && value.length === 0)) return (<></>);

    return (
        <dl className={classes}>
            <dt className={`fs-sm fw-medium opacity-75${inline ? ' col-5' : ''}`}>{title}</dt>
            <dd className={`fs-sm fw-semibold text-break mb-0${inline ? ' col' : ''}`}>{value}</dd>
        </dl>
    );
};

export default TableDetailList;
